var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    _vm._b(
      {
        scopedSlots: _vm._u(
          [
            {
              key: "activator",
              fn: function({ on }) {
                return [
                  _vm._t(
                    "trigger",
                    function() {
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              { attrs: { text: "", "x-small": "" } },
                              "v-btn",
                              _vm.attrs,
                              false
                            ),
                            on
                          ),
                          [_c("span", [_vm._v("Open")])]
                        )
                      ]
                    },
                    null,
                    { on, attrs: _vm.attrs }
                  )
                ]
              }
            }
          ],
          null,
          true
        ),
        model: {
          value: _vm.menu,
          callback: function($$v) {
            _vm.menu = $$v
          },
          expression: "menu"
        }
      },
      "v-menu",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            _vm._b(
              { attrs: { dense: "", flat: "", dark: "" } },
              "v-toolbar",
              _vm.$attrs,
              false
            ),
            [
              _vm._t("header", function() {
                return [
                  _c("v-icon", [_vm._v(_vm._s(_vm.icon))]),
                  _c("span", [_vm._v(_vm._s(_vm.title))])
                ]
              })
            ],
            2
          ),
          _c("v-container", [_vm._t("content")], 2),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _vm._t("actions", function() {
                return [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red", small: "", text: "", dense: "" },
                      on: {
                        click: function($event) {
                          _vm.menu = false
                        }
                      }
                    },
                    [_c("span", [_vm._v("Close")])]
                  )
                ]
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }